const initialState = {
    accessAdmin: true,
    displayNotification: false,
    notificationMessage: '',
    notificationType: 'error'
};

const fuseReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FUSE_NO_ADMIN_ACCESS': {
            return {
                ...state,
                accessAdmin: false,
                displayNotification: true,
                notificationMessage: 'Cannot access CloudSent POS Admin.',
                notificationType: 'error'
            }
        }
        case 'FUSE_NO_SERVER': {
            return {
                ...state,
                displayNotification: true,
                notificationMessage: 'No Server Available.',
                notificationType: 'error'
            }
        }
        default: {
            return state
        }
    }
};
export default fuseReducer;



// WEBPACK FOOTER //
// ./src/Fuse/admin/fuseReducer.js